import { axios as apiService } from '../axiosService';
import { fixModuleName } from '@utils/widget';
import { SEGMENTS, GotomarketDeafultFields } from '@model';
import { isUuid } from '@utils/common';
import { BASE_URL } from './index';
import { processSubsidiaries } from '@modules/analysis/detail/subsidiaries/grid/helper';

export const getTotalRevenue = async (id) => {
  // return await totalRevenueMockData.attributes;
  const res = await apiService.get(
    `${BASE_URL}/project/financials/chart/${id}?chartType=totalRevenue`,
  );
  return res?.attributes;
};

export const getMarketCap = async (id) =>
  await apiService.get(
    `${BASE_URL}/project/financials/chart/${id}?chartType=marketCap`,
  );

export const getStockDataRequest = (id) => {
  if (!id) {
    return null;
  }

  return apiService.get(
    `${BASE_URL}/project/stockExchange/${id}?needFormat=true`,
  );
};

export const getProjectAnalysisFinancials = (projectId) =>
  apiService.get(`${BASE_URL}/project/financials/${projectId}?needFormat=true`);

export const submitFiscalYearEnd = (projectId, inputData, infoType) => {
  const category = infoType === 'Note' ? 'note' : 'fiscalYearEnd';

  // 各字段对应的数据请求地址, 包括note请求！
  const arr = [
    ['Note', 'operationalFootprint/edit'],
    ['Fiscal Year End', 'edit'],
  ];
  const map = new Map(arr);
  const data = {
    input: Object.keys(inputData).map((k) => ({
      companyType: k,
      category,
      content: inputData[k] || '',
    })),
    project_id: projectId,
  };
  return apiService.post(`${BASE_URL}/project/${map.get(infoType)}`, data);
};

export const getFinancialDetails = async (projectId, resourceId) => {
  try {
    const data = await apiService.get(
      `${BASE_URL}/project/financials/chart/${projectId}?chartType=${resourceId}`,
    );
    return data;
  } catch (ex) {
    throw new Error(ex);
  }
};

const getESGStatus = (projectId) =>
  apiService.get(`${BASE_URL}/project/esgStatus/${projectId}`);

const getESGCSRdata = (projectId) =>
  apiService.get(`${BASE_URL}/project/esg/${projectId}`);

export const toggleESGEditStatus = (projectId, status) =>
  apiService.post(`${BASE_URL}/project/esgStatus/${projectId}`, {
    esgManualViewFlag: status,
  });

export const updateESGSummary = (projectId, summary) =>
  apiService.post(`${BASE_URL}/project/updateEsgSummary/${projectId}`, {
    summary,
  });

// this is the requested data for all modules.    ---analysis module
export const getAnalysisData = async (projectId, moduleName) => {
  try {
    if (moduleName === SEGMENTS.esgAndCsr) {
      const [esgData, esgStatus] = await Promise.all([
        getESGCSRdata(projectId),
        getESGStatus(projectId),
      ]);
      return { ...esgData, ...esgStatus };
    }
    const data =
      moduleName === 'Key Contacts'
        ? // this is the request for key-contacts module
          await apiService.get(`${BASE_URL}/project/keyContact/${projectId}`)
        : await apiService.get(
            `${BASE_URL}/project/${fixModuleName(
              moduleName,
            )}/${projectId}?needFormat=true`,
          );
    return data;
  } catch (ex) {
    throw new Error(ex);
  }
};

export const postGoToMarket = async (projectId, data) => {
  try {
    const res = await apiService.post(
      `${BASE_URL}/project/gotomarket/${projectId}`,
      data,
    );
    return res;
  } catch (ex) {
    throw new Error(ex);
  }
};
export const getSGAData = async (projectId) => {
  try {
    const data = await apiService.get(
      `${BASE_URL}/project/financials/chart/${projectId}?chartType=sgaExpense`,
    );
    return data;
  } catch (ex) {
    throw new Error(ex);
  }
};

export const getGTMCompData = async (projectId) => {
  try {
    // const data = await apiService.get(
    //   `${BASE_URL}/project/financials/chart/${projectId}?chartType=sgaExpense`,
    // );
    const data = [
      {
        companyName: 'Adidas',
        revenue: 29873600000,
        gmPct: 0.7300392319640083,
        smPct: 0.3082253226929463,
        gaPct: 0.20313253173370469,
        rdPct: 0.03298229875207541,
      },
      {
        companyName: 'Nike',
        revenue: 910299173600000,
        gmPct: 0.8100392319640083,
        smPct: 0.4082253226929463,
        gaPct: 0.22313253173370469,
        rdPct: 0.02298229875207541,
      },
      {
        companyName: 'Puma',
        revenue: 112193600000,
        gmPct: 0.2100392319640083,
        smPct: 0.6282253226929463,
        gaPct: 0.81313253173370469,
        rdPct: 0.04298229875207541,
      },
    ];
    await new Promise((resolve) => setTimeout(resolve, 1000));
    return data;
  } catch (ex) {
    throw new Error(ex);
  }
};

export const postSGAData = async (projectId, data) => {
  try {
    const respData = await apiService.post(
      `${BASE_URL}/project/financials/chart/${projectId}?chartType=sgaExpense`,
      data,
    );
    return respData;
  } catch (ex) {
    throw new Error(ex);
  }
};

export const getGPrinciples = async (project_id, companyInstance) => {
  try {
    const respData = await apiService.get(
      `${BASE_URL}/project/insight/${project_id}${
        companyInstance ? `?type=${companyInstance}` : ''
      }`,
    );
    return respData.guidingPrincipleList;
  } catch (ex) {
    throw new Error(ex);
  }
};

// key contacts 页面的请求 --开始
export const postKeyContactsData = async (projectId, data) => {
  try {
    const res = await apiService.post(
      `${BASE_URL}/project/keyContact/${projectId}`,
      data,
    );
    return res;
  } catch (ex) {
    throw new Error(ex);
  }
};
// key contacts 页面的请求 --结束

export const postDealRationale = async (data) => {
  try {
    const res = await apiService.post(
      `${BASE_URL}/project/dealRationale/${data.projectId}`,
      data,
    );
    return res;
  } catch (ex) {
    throw new Error(ex);
  }
};

export const getCompanyHistoryDataRequest = (projectId) => {
  if (!projectId) {
    return null;
  }

  return apiService.get(`${BASE_URL}/project/companyHistory/${projectId}`);
};

export const getPowerBiEmbedComfig = (url) =>
  apiService.get(`${BASE_URL}/project${url}`);

export const postSentimentAnalysis = async (projectId, summary) => {
  try {
    const res = await apiService.post(
      `${BASE_URL}/project/sentimentAnalysis/${projectId}`,
      { summary },
    );
    return res;
  } catch (ex) {
    throw new Error(ex);
  }
};
export const getOtherDetails = async (projectId, moduleName) => {
  const data = await apiService.get(
    `${BASE_URL}/project/${moduleName}/${projectId}`,
  );
  if (moduleName === 'subsidiary') {
    return processSubsidiaries(data);
  }
  return data;
  // try {
  //   const data = await apiService.get(
  //     `${BASE_URL}/project/${moduleName}/${projectId}`,
  //   );
  //   if(moduleName === 'subsidiary') {
  //     return processSubsidiaries(data);
  //   }
  //   return data;
  // } catch (ex) {
  //   throw new Error(ex);
  // }
};

export const uploadLESubExcel = (projectId, data) => {
  const url = `${BASE_URL}/project/subsidiary/${projectId}/report`;
  return apiService.post(url, data, {
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' },
    timeout: 0,
  });
};

export const getLEUploadHistory = (projectId) => {
  const url = `${BASE_URL}/project/subsidiary/${projectId}/report/history`;
  return apiService.get(url);
};

export const resetLESubsidiaries = (projectId) => {
  const url = `${BASE_URL}/project/subsidiary/reset/${projectId}`;
  return apiService.get(url);
};

export const getHeadcountSales = (projectId) => {
  const url = `${BASE_URL}/project/headcountAndSales/${projectId}`;
  return apiService.get(url);
};

export const updateCategories = (projectId, selectedMenu, updateList) => {
  const categoryList = [];
  const customizevalueList = [];
  const postContentList = updateList.map((e) => ({
    identifier: [...GotomarketDeafultFields].includes(e.name) ? e.name : e.id,
    categoryName: e.name,
    hideFlag: Boolean(e.isHidden),
    displayOrder: e.order,
  }));

  postContentList.forEach((e) => {
    if (isUuid(e.identifier)) {
      customizevalueList.push(e);
    } else {
      categoryList.push(e);
    }
  });

  const url = `${BASE_URL}/project/customizeCategory/${projectId}`;
  return apiService.post(url, {
    customizeCategoryInfo: {
      segmentName: fixModuleName(selectedMenu),
      categoryList,
      customizevalueList,
    },
  });
};

export const submitCompanyOverviewCustomizeValues = (
  projectId,
  inputData,
  uuid,
) => {
  const url = `${BASE_URL}/project/customizeValues/${projectId}`;
  return apiService.post(url, {
    id: uuid,
    value: inputData,
  });
};
